let Public = localStorage.getItem("publicData");
const state = {
  crumbsCont: "",
  token: "771729f07e7bc338a4c050fc134c6eede15db878",
  app_id: "332",
  merch_id: "100",
  status: "online",
  publicData: JSON.parse(Public),
  pageLimit: {
    status: false, //false 没有权限划分
    pathData: []
  },
  newData:[],
  inviteForm: {},
  emp_id: localStorage.getItem("choseStaffId")
    ? localStorage.getItem("choseStaffId")
    : 0
};

const mutations = {
  CRUMNS_CONT(state, crumbsCont) {
    state.crumbsCont = crumbsCont;
  },
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_APPID(state, appid) {
    state.app_id = appid;
  },
  SET_STATUS(state, status) {
    state.status = status;
  },
  SET_PUBLICDATA(state, publicData) {
    localStorage.setItem("publicData", JSON.stringify(publicData));
    state.publicData = publicData;
  },
  SET_PAGELIMIT(state, pathData) {
    state.pageLimit = pathData;
  },
  SET_INVITEFORM(state, inviteForm) {
    state.inviteForm = inviteForm;
  },
  SET_EMP(state, emp) {
    state.emp_id = emp.id;
  },
  SET_NEWDATA(state, data) {
    state.newData = data;
  }
};
const actions = {
  changeCrum({ commit }, crumbsCont) {
    commit("CRUMNS_CONT", crumbsCont);
  }
};

export default {
  state,
  mutations,
  actions
};
